import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Cookies from 'js-cookie'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import Vant from 'vant';
import 'vant/lib/index.css';

import App from './App'
import router from './router'
import store from './store'
import './permission' // permission control
import i18n from './lang' // Internationalization

import * as filters from './filters' // global filters

Vue.use(Vant);
Vue.config.productionTip = false

Vue.use(Element, {
  size: Cookies.get('size') || 'medium'
})

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js